import React, { useState } from 'react';
import { Box, Card, Button, IconButton, Collapse, TextField } from '@mui/material';
import Form from 'react-bootstrap/Form';
import RefreshIcon from '@mui/icons-material/Refresh';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import {useTheme} from "@mui/material/styles";
import {useSidebar} from "../Context/SidebarContext";
import styled from "@emotion/styled";

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: "transform 0.3s",
}));

const TransactionFilterCard = ({ handleSearch, initialFilters }) => {
  const [transactionId, setTransactionId] = useState(initialFilters?.transactionId ?? "");
  const [commune, setCommune] = useState(initialFilters?.commune ?? "");
  const [address, setAddress] = useState(initialFilters?.address ?? "");
  const [sellers, setSellers] = useState(initialFilters?.sellers ?? "");
  const [buyers, setBuyers] = useState(initialFilters?.buyers ?? "");
  const [startDate, setStartDate] = useState(initialFilters?.startDate ?? null);
  const [endDate, setEndDate] = useState(initialFilters?.endDate ?? null);
  const [minPrice, setMinPrice] = useState(initialFilters?.minPrice ?? "");
  const [maxPrice, setMaxPrice] = useState(initialFilters?.maxPrice ?? "");
  const [showAllFields, setShowAllFields] = useState(false);
  const theme = useTheme();
  const { isOpen } = useSidebar();

  const onClickValidate = () => {
    let newFilters = {};
    if (transactionId) newFilters.transactionNumber = transactionId;
    if (commune) newFilters.city = commune;
    if (address) newFilters.address = address;
    if (sellers) newFilters.sellers = sellers;
    if (buyers) newFilters.buyers = buyers;
    if (startDate) newFilters.startDate = startDate.toISOString().split('T')[0];
    if (endDate) newFilters.endDate = endDate.toISOString().split('T')[0];
    if (minPrice) newFilters.minPrice = Number(minPrice);
    if (maxPrice) newFilters.maxPrice = Number(maxPrice);

    newFilters.size = 10;
    newFilters.page = 0;
    newFilters.isEmpty = false;

    handleSearch(newFilters);
  };

  const onClickClean = () => {
    setTransactionId("");
    setCommune("");
    setAddress("");
    setSellers("");
    setBuyers("");
    setStartDate(null);
    setEndDate(null);
    setMinPrice("");
    setMaxPrice("");

    handleSearch({ isEmpty: true });
  };

  const filterPos = {
    position: "fixed",
    top: "20px",
    width: "22%",
    maxHeight: "90vh",
    transition: "all 0.3s ease",
    padding: "20px",
    backgroundColor: "#fff",
    '& .MuiFormGroup-root': {
      marginBottom: '1rem'
    },
    '& .MuiTextField-root': {
      marginBottom: '0.5rem'
    },


    [theme.breakpoints.down('lg')]: {
      width: "28%",
      marginRight: "5px"
    },
    [theme.breakpoints.down('md')]: {
      position: "inherit",
      width: "100%"
    },
    [theme.breakpoints.down('sm')]: {
      position: "inherit",
      width: "100%"
    },
  };

  const openFilterPos = {


    position: "fixed",
    top: "20px",
    width: "19%",
    maxHeight: "90vh",
    transition: "all 0.3s ease",
    padding: "20px",
    backgroundColor: "#fff",
    '& .MuiFormGroup-root': {
      marginBottom: '1rem'
    },
    '& .MuiTextField-root': {
      marginBottom: '0.5rem'
    },

    [theme.breakpoints.down('lg')]: {
      width: "100%",
      position: "inherit"
    },
    [theme.breakpoints.down('md')]: {
      position: "inherit",
      width: "100%"
    },
    [theme.breakpoints.down('sm')]: {
      position: "inherit",
      width: "100%"
    },
  }

  const handleExpandClick = () => {
    setShowAllFields(!showAllFields);
  };



  return (
    <Card className="shadow-none"
    sx={
      isOpen ? openFilterPos : filterPos
    }>
      <Box component="form">
        <Form.Group className="my-3" key="transactionId">
          <TextField
            type="text"
            label="N° Transaction"
            placeholder="N° Transaction"
            fullWidth
            value={transactionId}
            onChange={(e) => setTransactionId(e.target.value)}
            size="small"
          />
        </Form.Group>
        <Form.Group className="my-3" key="commune">
          <TextField
            type="text"
            label="Commune"
            placeholder="Commune"
            fullWidth
            value={commune}
            onChange={(e) => setCommune(e.target.value)}
            size="small"
          />
        </Form.Group>
        <IconButton
          onClick={handleExpandClick}
          sx={{"&:hover": {background: "none"}, p: 0}}
        >
          {showAllFields ? 
            <><span style={{fontSize: "14px"}}>Afficher moins</span> <ExpandLessIcon /></> : 
            <><span style={{fontSize: "14px"}}>Filtre avancé</span><ExpandMoreIcon /></>
          }
        </IconButton>
        <Collapse in={showAllFields} timeout="auto" unmountOnExit>
          <Form.Group className="my-3" key="address">
            <TextField
              type="text"
              label="Adresse"
              placeholder="Adresse"
              fullWidth
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              size="small"
            />
          </Form.Group>
          <Form.Group className="my-3" key="sellers">
            <TextField
              type="text"
              label="Vendeurs"
              placeholder="Vendeurs"
              fullWidth
              value={sellers}
              onChange={(e) => setSellers(e.target.value)}
              size="small"
            />
          </Form.Group>
          <Form.Group className="my-3" key="buyers">
            <TextField
              type="text"
              label="Acheteurs"
              placeholder="Acheteurs"
              fullWidth
              value={buyers}
              onChange={(e) => setBuyers(e.target.value)}
              size="small"
            />
          </Form.Group>
        </Collapse>
        <Box sx={{ display: 'flex', mt: 3, justifyContent: "flex-end" }}>
          <Button
            sx={{
              background: "#757575",
              color: "#fff",
              "&:hover": { background: "#757575" },
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              verticalAlign: "center",
              fontWeight: 500
            }}
            onClick={onClickClean}
          >
            <RefreshIcon sx={{mr: 1, fontSize: 18}} />
            REINITIALISER
          </Button>
          <Button
            sx={{
              background: "#299CDB",
              color: "#fff",
              "&:hover": { background: "#299CDB" },
              ml: 1
            }}
            onClick={onClickValidate}
          >
            Filtrer
          </Button>
        </Box>
      </Box>
    </Card>
  );
};

export default TransactionFilterCard; 